// extracted by css-extract-rspack-plugin
export default {"FacetOption":"FacetOption-module__FacetOption__uEJHa","TrailingAction":"FacetOption-module__TrailingAction__O0iko","TruncateWrap":"FacetOption-module__TruncateWrap__fzdoI"};